
import React from "react";
import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Suspense, lazy } from 'react';
import SessionTimeoutRedirect from '../Components/Common/SessionTimeoutRedirect'
import SkeletonL from "../Components/Skeleton/Withlogin";
// import Duefee from "../Components/Dashboard/Manage-My-Program/Duefee";
const Duefee =lazy(() => import('../Components/Dashboard/Manage-My-Program/Duefee'));
const AuthDuefee = () => {
   const useAuth=()=>{
    const user=localStorage.getItem('user_id')
    const token = document.cookie.replace(/(?:(?:^|.*;\s*)token\s*=\s*([^;]*).*$)|^.*$/, '$1');

    if(token){
      return true
    } else {
      localStorage.clear()
      return false
    }
  }
  const auth = useAuth();
  return auth ?  <Suspense fallback={<SkeletonL/>}>
  <Duefee/>
</Suspense> : <SessionTimeoutRedirect />
}
export default AuthDuefee;


